import React from 'react'
import {faUser} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"

export default function StudentCount ({groups, translate}) {
    const studentCount = groups.reduce((count, group) => count + group.students.length, 0)
    console.log(studentCount)
    return (
      <div className="student-count">
        <div className="icon">
          <FontAwesomeIcon icon={faUser} />
        </div>
        <div className="count">
          {studentCount}{" "}{translate(`student${studentCount == 1 ? '' : 's'}_label`)}
        </div>
      </div>
    )
}
